import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    // 路由重新定向
    {
        path: "/",
        redirect: "/freight",
    },
    { // 运价列表
        path: '/login', 
        name: 'login',
        component: () => import("@/views/HP/LoginPage.vue"),
    },
    {
        path: "/freight",
        name: 'HomePage',
        redirect: "/freight",
        component: () => import("@/views/HP/HomePage.vue"),
        children:[
            { // 运价列表
                path: '/userInfo', 
                name: 'userInfo',
                component: () => import("@/views/HP/UserInfo.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            { // 运价列表
                path: '/freight', 
                name: 'freight',
                component: () => import("@/views/List/freightList.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            { // 发布运价
                path: '/newFreight',  
                name: 'newFreight',
                component: () => import("@/views/List/newFreight.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/template',
                name: 'template',
                component: () => import("@/views/Template/template.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/newTemplate',
                name: 'newTemplate',
                component: () => import("@/views/Template/newTemplate.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
        ]
    },
    
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// meta: {
//   requiresAuth: true,
//   content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
// },

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};


const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err);
}


router.beforeEach((to,from, next) => {
    console.log('路由切换',to,from);
    const isLoginRequired = to.matched.some(record => record.meta.requiresAuth)
    const isLogin = localStorage.getItem('isLoginSvp')
    if (isLoginRequired && !isLogin) {
        next('/login') // 未登录则重定向到登录页面
    }else {
        // 已登录，或者不需要登录的页面，正常导航
        next()
    }
})

router.afterEach((to, from) => {
    // 在路由切换后滚动到页面顶部
    console.log('路由切换',to.path,from.path);
    if (to.path !== from.path) {
        window.scrollTo(0, 0); // 将滚动条位置设置到页面最顶部
    }
})



export default router
